<script setup lang="ts">
  import useHeaderDataLayer from '@/composables/data-layers/useHeaderDataLayer'

  interface ILoggedOut {
    title: string
    loginUrl: string
  }

  const { isDesktop } = useBTBreakpoints()

  const { pushHeaderLoginClickDataLayer } = useHeaderDataLayer()

  defineProps<ILoggedOut>()
</script>

<template>
  <NuxtLink
    class="flex items-center justify-center gap-2 rounded text-sm font-medium no-underline"
    :aria-label="title"
    :to="loginUrl"
    external
    @click="pushHeaderLoginClickDataLayer"
  >
    <Icon name="common/person" />
    <span v-if="isDesktop">
      {{ title }}
    </span>
  </NuxtLink>
</template>
